import React, { ChangeEvent } from "react";
import { FormState } from "./VcApplication";
interface PersonFormProps {
    forms: FormState[];
    setForms: React.Dispatch<React.SetStateAction<FormState[]>>;
    title: string;
  }
const PersonForm: React.FC<PersonFormProps> = ({ forms, setForms, title }) => {
    const handleInputChange = (index: number, event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = event.target;
      const newForms = [...forms];
      newForms[index] = { ...newForms[index], [name]: value };
      setForms(newForms);
    };
  
    const addForm = () => {
      setForms((prevForms) => [
        ...prevForms,
        { firstName: "", lastName: "", middleName: "", email: "", mobile: "", address: "" },
      ]);
    };
  
    const removeForm = (index: number) => {
      const newForms = forms.filter((_, i) => i !== index);
      setForms(newForms);
    };
  
    return (
      <div className="flex flex-col mt-5 gap-5">
        <h3 className="form-subheader">{title}</h3>
        {forms.map((form, index) => (
          <div key={index} style={{ marginBottom: "1rem" }} className="flex flex-col gap-3">
            <div className="flex gap-5">
              <h4 className="font-bold">
                {index + 1}
                {index === 0 ? "st" : index === 1 ? "nd" : index === 2 ? "rd" : "th"} {title}
              </h4>
              <button type="button" onClick={() => removeForm(index)}>
                Cancel
              </button>
            </div>
            <div className="flex flex-col md:flex-row gap-5 w-full">
              <div className="flex flex-col">
                <label htmlFor={`${title.toLowerCase().replace(" ", "-")}-firstName-${index}`}>First Name:</label>
                <input
                  type="text"
                  id={`${title.toLowerCase().replace(" ", "-")}-firstName-${index}`}
                  name="firstName"
                  placeholder="Input First Name"
                  value={form.firstName}
                  onChange={(event) => handleInputChange(index, event)}
                  className="vc-reg-input"
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor={`${title.toLowerCase().replace(" ", "-")}-middleName-${index}`}>Middle Name:</label>
                <input
                  type="text"
                  id={`${title.toLowerCase().replace(" ", "-")}-middleName-${index}`}
                  name="middleName"
                  placeholder="Input Middle Name"
                  value={form.middleName}
                  onChange={(event) => handleInputChange(index, event)}
                  className="vc-reg-input"
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor={`${title.toLowerCase().replace(" ", "-")}-lastName-${index}`}>Last Name:</label>
                <input
                  type="text"
                  id={`${title.toLowerCase().replace(" ", "-")}-lastName-${index}`}
                  name="lastName"
                  placeholder="Input Last Name"
                  value={form.lastName}
                  onChange={(event) => handleInputChange(index, event)}
                  className="vc-reg-input"
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor={`${title.toLowerCase().replace(" ", "-")}-email-${index}`}>Email:</label>
                <input
                  type="email"
                  id={`${title.toLowerCase().replace(" ", "-")}-email-${index}`}
                  name="email"
                  placeholder="Input Email Address"
                  value={form.email}
                  onChange={(event) => handleInputChange(index, event)}
                  className="vc-reg-input"
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-5 w-full">
              <div className="flex flex-col w-[30%]">
                <label htmlFor={`${title.toLowerCase().replace(" ", "-")}-mobile-${index}`}>Phone Number:</label>
                <input
                  id={`${title.toLowerCase().replace(" ", "-")}-mobile-${index}`}
                  name="mobile"
                  placeholder="Input Your Phone Number"
                  value={form.mobile}
                  onChange={(event) => handleInputChange(index, event)}
                  className="vc-reg-input"
                />
              </div>
              <div className="flex flex-col w-full">
                <label htmlFor={`${title.toLowerCase().replace(" ", "-")}-address-${index}`}>Address:</label>
                <input
                  id={`${title.toLowerCase().replace(" ", "-")}-address-${index}`}
                  name="address"
                  placeholder="Input Address"
                  value={form.address}
                  onChange={(event) => handleInputChange(index, event)}
                  className="vc-reg-input"
                />
              </div>
            </div>
            <button type="button" onClick={addForm} className="text-left font-bold">
              Add {title.split(" ")}
            </button>
          </div>
        ))}
        
      </div>
    );
  };
  export default PersonForm;